import React, { useState, useEffect, useRef, useMemo } from 'react';
import { graphic } from 'echarts';
import * as echarts from 'echarts';
import ECharts, { EChartsReactProps } from 'echarts-for-react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useClientStore from '../stores/client';
import alarm from '../assets/sound/beep1.mp3';
import { useTranslation } from 'react-i18next';
import i18n from '../stores/i18n';


import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../css/calendar.css';
import UnUseIcon from '../assets/block.gif';
import UseIcon_c from '../assets/chair_use.gif';
import UseIcon_m from '../assets/location.gif';
import UseIcon_b from '../assets/goto_sleep.gif';
import UseIcon_s from '../assets/pillow.gif';
import Apnea_icon from '../assets/insomnia.gif';
//import UseIcon_Baby from '../assets/newborn.gif';

import { Get, Delete, GetPredict } from '../lib/Device';
import { GetListLast, GetUsage } from '../lib/DeviceData';
import { calculateAge, checkCanPlay, gapTime, typeSex, isOccupiedBySense } from '../lib/Common';
import moment from 'moment';
import MonitoringDetailBottom from './monitoring_detail_bottom';
import { AuthMe } from '../lib/MyHttp';
import { deviceState } from './monitoring_realtime_cell';
import { BsList } from 'react-icons/bs';
import { AiOutlineAppstore } from 'react-icons/ai';
import HrvDash from '../components/hrv_dash';
// import HrvDashnew from '../components/hrv_new_dash';

const emptyData = {
    tooltip: {
        show: 'false',
    },
    xAxis: {
        show: false,
        boundaryGap: false,
        data: [],
    },
    yAxis: {
        show: false,
        type: 'value',
    },
    grid: {
        top: 10,
        left: 0,
        right: 0,
        bottom: 0,
    },
    series: [
        {
            name: 'BPM',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: {
                color: '#7E7E7E',
                width: 3,
            },
            data: [],
        },
    ],
};

const MonitoringDetail = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { id } = useParams();
    // MQTT 센서 구독용 (현재 서버 폴링으로 대체 — 복구 시 주석 해제)
    // const { client, addOnMessage, removeOnMessage } = useClientStore();
    const [audio] = useState(new Audio(alarm));
    const [canPlay, setCanPlay] = useState(false);
    const [myInfo, setMyInfo] = useState(false);

    const [data, setData] = useState();
    // const [client, setClient] = useState();
    const [showType, setShowType] = useState('cell');

    const [device_AI, setDeviceAi] = useState('N');

    // 심정지 위험도 Predict API 상태
    const [aiResult, setAiResult] = useState(null); // 0.0 ~ 1.0
    const [aiScore, setAiScore] = useState(null); // result * 100
    const [aiLabel, setAiLabel] = useState(null); // 낮음 | 주의 | 높음
    const [aiSampleCount, setAiSampleCount] = useState(null);
    const [aiFrom, setAiFrom] = useState(null);
    const [aiTo, setAiTo] = useState(null);
    const [aiHrAvg, setAiHrAvg] = useState(null);
    const [aiRrAvg, setAiRrAvg] = useState(null);
    const [aiRows, setAiRows] = useState([]);
    const [aiRange, setAiRange] = useState(null);
    const [aiError, setAiError] = useState(null);
    const [aiEmpty, setAiEmpty] = useState(false);
    const [aiReady, setAiReady] = useState(null);
    const [aiObserved, setAiObserved] = useState(null);
    const [aiRequired, setAiRequired] = useState(null);
    const AI_PREDICT_SIZE = 60;

    // 심박수
    const [values1, setValues1] = useState([]);
    const [label1, setLabel1] = useState([]);
    const [value1, setValue1] = useState(0);

    // 호흡수
    const [values2, setValues2] = useState([]);
    const [label2, setLabel2] = useState([]);
    const [value2, setValue2] = useState(0);

    // 산소불포화
    const [values3, setValues3] = useState([]);
    const [label3, setLabel3] = useState([]);
    const [value3, setValue3] = useState(0);

    // 압력값
    const [values5, setValues5] = useState([]);
    const [label5, setLabel5] = useState([]);
    const [value5, setValue5] = useState(0);
    const [value6, setMotionDetected] = useState(0);
    const [lastMeasuredAt, setLastMeasuredAt] = useState(null);
    const [usage, setUsage] = useState(null);
    const [usageTick, setUsageTick] = useState(0);
    const [aiLineTick, setAiLineTick] = useState(0);

    // 호흡수
    const [Apneas, setApneas] = useState([]);
    const [isApnea, setisApnea] = useState(0);

    const dataRef = useRef(data);
    const lastMqttAtRef = useRef(0);
    const isUseRef = useRef(false);
    const seriesHasDataRef = useRef(false);
    const predictFrozenRef = useRef(false);

    useEffect(() => {
        dataRef.current = data;
    }, [data]);

    /*
    // ===== [이전] MQTT 센서 구독 (복구 시 이 블록 + useClientStore 주석 해제) =====
    const topicRef = useRef('');
    useEffect(() => {
        if (!data?.device_sn) return;

        const topic = `SmartMat/${data.device_sn}/Autowells-server/pub_sense_data`;
        topicRef.current = topic;

        const onMessage = (msgTopic, message) => {
            if (topicRef.current !== msgTopic) return;
            try {
                const msg = JSON.parse(message);
                if (msg.e && dataRef.current) {
                    procData(dataRef.current, msg.e);
                }
            } catch (err) {
                console.error('sense_data parse error:', err);
            }
        };

        if (client) {
            client.subscribe(topic, error => {
                if (error) {
                    console.log('Subscribe to topics error', error);
                }
            });
        }

        addOnMessage(topic, onMessage);

        return () => {
            if (client) {
                client.unsubscribe(topic, error => {
                    if (error) {
                        console.log('Unsubscribe error', error);
                    }
                });
            }
            removeOnMessage(topic);
        };
    }, [data?.device_sn, client]);
    // ===== MQTT 끝 =====
    */

    // 서버 센서 폴링: /deviceData/last 시계열을 파형·카드에 통째로 리로드 (MQTT 대체)
    const SENSE_POLL_MS = 2000;
    const SENSE_SERIES_MAX = 60;

    const normalizeSenseRows = res => {
        if (!res) return [];
        if (Array.isArray(res)) return res;
        if (Array.isArray(res.rows)) {
            // rows가 최신순이면 시간순으로
            return [...res.rows].reverse();
        }
        if (Array.isArray(res.e) || res.heart != null || res.hr != null || res.fsr != null || res.fsr_sum != null) {
            return [res];
        }
        return [];
    };

    const rowTimeRaw = row => row?.time || row?.bucket || row?.reg_date || row?.to || null;

    const rowTimeLabel = row => {
        const t = rowTimeRaw(row);
        return t ? moment(t).format('HH:mm:ss') : moment().format('HH:mm:ss');
    };

    const rowHeart = row => {
        if (Array.isArray(row?.e)) return Number(row.e[0] ?? 0);
        return Number(row?.heart ?? row?.hr ?? row?.hr_avg ?? 0);
    };

    const rowResp = row => {
        if (Array.isArray(row?.e)) return Number(row.e[1] ?? 0);
        return Number(row?.resp ?? row?.rr ?? row?.rr_avg ?? 0);
    };

    const rowFsr = row => {
        if (Array.isArray(row?.e)) return Number(row.e[4] ?? 0);
        return Number(row?.fsr_sum ?? row?.fsr ?? 0);
    };

    const toSenseArray = row => {
        if (!row) return null;
        if (Array.isArray(row)) return row;
        if (Array.isArray(row.e)) return row.e;

        const heart = rowHeart(row);
        const resp = rowResp(row);
        const apnea = Number(row.apnea ?? 0);
        const state = Number(row.state ?? 0);
        const fsr = rowFsr(row);
        const motion = Number(row.motion_detected ?? row.motion ?? 0);
        return [heart, resp, apnea, state, fsr, 0, 0, 0, 0, 0, 0, motion];
    };

    const pickLastMeasuredAt = rows => {
        if (!rows?.length) return null;
        for (let i = rows.length - 1; i >= 0; i--) {
            const sense = toSenseArray(rows[i]);
            if (sense && isOccupiedBySense(sense[4], sense[11])) {
                return rowTimeRaw(rows[i]);
            }
        }
        return rowTimeRaw(rows[rows.length - 1]);
    };

    // REAL TIME GRAPH / list 미니파형 / 카드에 동일 시계열 리로드
    const reloadSenseSeries = rows => {
        const sliced = rows.slice(-SENSE_SERIES_MAX);
        const times = sliced.map(rowTimeLabel);
        const hearts = sliced.map(rowHeart);
        const resps = sliced.map(rowResp);
        const fsrs = sliced.map(rowFsr);

        setLabel1(times);
        setLabel2(times);
        setLabel5(times);
        setValues1(hearts);
        setValues2(resps);
        setValues5(fsrs);
        if (sliced.length) seriesHasDataRef.current = true;
        const measuredAt = pickLastMeasuredAt(rows);
        if (measuredAt) setLastMeasuredAt(measuredAt);
    };

    useEffect(() => {
        const deviceNo = data?.device_no || id;
        if (!deviceNo) return;

        seriesHasDataRef.current = false;
        setLastMeasuredAt(null);

        const MQTT_FRESH_MS = 15000;

        const fetchSense = () => {
            GetListLast(
                { id: deviceNo, device_no: deviceNo },
                res => {
                    const mqttFresh = Date.now() - lastMqttAtRef.current < MQTT_FRESH_MS;
                    const device = dataRef.current;

                    const rows = normalizeSenseRows(res);
                    if (!rows.length) {
                        if (!seriesHasDataRef.current && !mqttFresh) {
                            if (device?.online) {
                                device.online = false;
                                setData({ ...device });
                            }
                            setValue1(0);
                            setValue2(0);
                            setValue5(0);
                            isUseRef.current = false;
                        }
                        return;
                    }

                    const latest = rows[rows.length - 1];
                    const sense = toSenseArray(latest);
                    const inUse = sense ? isOccupiedBySense(sense[4], sense[11]) : false;

                    if ((mqttFresh ? isUseRef.current : isUseRef.current || inUse) || !seriesHasDataRef.current) {
                        reloadSenseSeries(rows);
                    }

                    if (device && sense) {
                        procData(device, sense, { skipSeries: true, hrRrOnly: mqttFresh });
                    } else if (sense) {
                        setValue1(sense[0]);
                        setValue2(sense[1]);
                        if (!mqttFresh) {
                            setValue5(sense[4]);
                            isUseRef.current = inUse;
                        }
                    }
                },
                err => {
                    console.log('deviceData/last poll error', err?.message || err);
                },
            );
        };

        fetchSense();
        const timer = setInterval(fetchSense, SENSE_POLL_MS);
        return () => clearInterval(timer);
    }, [data?.device_no, id]);

    useEffect(() => {
        const deviceNo = data?.device_no || id;
        if (!deviceNo) return;

        const fetchUsage = () => {
            GetUsage({ device_no: deviceNo, id: deviceNo }, res => setUsage(res));
        };
        fetchUsage();
        const timer = setInterval(fetchUsage, 10 * 1000);
        return () => clearInterval(timer);
    }, [data?.device_no, id]);

    useEffect(() => {
        if (!usage?.in_use) return;
        const timer = setInterval(() => setUsageTick(n => n + 1), 1000);
        return () => clearInterval(timer);
    }, [usage?.in_use, usage?.session_started_at]);

    useEffect(() => {
        const hasChart = (aiRows || []).some(row => row && row.score != null);
        if (!hasChart) return;
        const timer = setInterval(() => setAiLineTick(n => n + 1), 5000);
        return () => clearInterval(timer);
    }, [aiRows]);

    // 심정지 위험도: 1분 주기 REST 조회
    useEffect(() => {
        if (!data || data.device_info !== 'Y') return;

        const deviceNo = data.device_no || id;
        predictFrozenRef.current = false;

        const clearPredict = () => {
            setAiResult(null);
            setAiScore(null);
            setAiLabel(null);
            setAiSampleCount(null);
            setAiFrom(null);
            setAiTo(null);
            setAiHrAvg(null);
            setAiRrAvg(null);
            setAiReady(null);
            setAiObserved(null);
            setAiRequired(null);
        };

        const applyPredict = res => {
            const rows = Array.isArray(res?.rows)
                ? res.rows
                : res?.result != null || res?.score != null
                  ? [res]
                  : [];
            const latest = rows[0];
            const unavailable =
                res?.ready === false ||
                res?.label === '데이터 확인 불가' ||
                (typeof res?.message === 'string' && res.message.includes('확인할 수 없습니다'));

            if (typeof window === 'undefined' || window.__PREDICT_DEBUG__ !== false) {
                console.log('[Predict] response', {
                    at: new Date().toISOString(),
                    device_no: deviceNo,
                    ready: res?.ready,
                    observed_minutes: res?.observed_minutes,
                    required_minutes: res?.required_minutes,
                    message: res?.message,
                    label: res?.label,
                    score: res?.score,
                    row_count: rows.length,
                    raw: res,
                });
            }

            setAiRows(rows);
            setAiRange(res?.range || null);
            setAiObserved(
                res?.observed_minutes != null ? Number(res.observed_minutes) : null,
            );
            setAiRequired(
                res?.required_minutes != null ? Number(res.required_minutes) : 60,
            );

            if (unavailable) {
                clearPredict();
                setAiRows(rows);
                setAiReady(false);
                setAiEmpty(false);
                setAiError(null);
                setAiLabel('데이터 확인 불가');
                setAiSampleCount(
                    res?.sample_count != null ? Number(res.sample_count) : null,
                );
                setAiObserved(
                    res?.observed_minutes != null ? Number(res.observed_minutes) : null,
                );
                setAiRequired(
                    res?.required_minutes != null ? Number(res.required_minutes) : 60,
                );
                return;
            }

            const scoreSrc = res?.score != null ? res : latest;
            if (!scoreSrc || (scoreSrc.score == null && scoreSrc.result == null)) {
                clearPredict();
                setAiEmpty(true);
                setAiReady(res?.ready ?? null);
                setAiError(null);
                return;
            }

            setAiReady(true);
            setAiEmpty(false);
            setAiResult(scoreSrc.result != null ? Number(scoreSrc.result) : null);
            setAiScore(
                scoreSrc.score != null
                    ? Number(scoreSrc.score)
                    : scoreSrc.result != null
                      ? Number(scoreSrc.result) * 100
                      : null,
            );
            setAiLabel(typeof scoreSrc.label === 'string' ? scoreSrc.label : null);
            setAiSampleCount(
                scoreSrc.sample_count != null ? Number(scoreSrc.sample_count) : null,
            );
            setAiFrom(scoreSrc.from || null);
            setAiTo(scoreSrc.to || null);
            setAiHrAvg(
                scoreSrc.hr_avg != null
                    ? Number(scoreSrc.hr_avg)
                    : scoreSrc.factors?.hr_last != null
                      ? Number(scoreSrc.factors.hr_last)
                      : null,
            );
            setAiRrAvg(
                scoreSrc.rr_avg != null
                    ? Number(scoreSrc.rr_avg)
                    : scoreSrc.factors?.rr_last != null
                      ? Number(scoreSrc.factors.rr_last)
                      : null,
            );
            setAiError(null);
        };

        const fetchPredict = () => {
            if (!isUseRef.current && predictFrozenRef.current) return;

            GetPredict(
                deviceNo,
                AI_PREDICT_SIZE,
                res => {
                    applyPredict(res);
                    if (!isUseRef.current) predictFrozenRef.current = true;
                },
                err => {
                    const body = err?.response?.data;
                    if (body && (body.ready === false || body.label === '데이터 확인 불가')) {
                        applyPredict(body);
                        if (!isUseRef.current) predictFrozenRef.current = true;
                        return;
                    }
                    const raw =
                        body?.message ||
                        err?.message ||
                        'cardiac arrest risk prediction failed';
                    if (typeof window === 'undefined' || window.__PREDICT_DEBUG__ !== false) {
                        console.warn('[Predict] error', {
                            at: new Date().toISOString(),
                            device_no: deviceNo,
                            size: AI_PREDICT_SIZE,
                            message: raw,
                            response_data: err?.response?.data,
                        });
                    }
                    const shortage = String(raw).match(
                        /Not enough samples for prediction \(need (\d+), got (\d+)\)/i,
                    );
                    if (shortage) {
                        clearPredict();
                        setAiRows([]);
                        setAiEmpty(false);
                        setAiSampleCount(Number(shortage[2]));
                        setAiError(
                            `데이터 수집 중 (${shortage[2]}/${shortage[1]}) · 약 1분 분량 필요`,
                        );
                        if (!isUseRef.current) predictFrozenRef.current = true;
                        return;
                    }
                    setAiEmpty(false);
                    setAiError(raw);
                    if (!isUseRef.current) predictFrozenRef.current = true;
                },
            );
        };

        fetchPredict();
        const timer = setInterval(fetchPredict, 60 * 1000);
        return () => clearInterval(timer);
    }, [data?.device_no, data?.device_info, id]);


    useEffect(() => {
        loadLastData();


        checkCanPlay().then(result => {
            if (result !== false) {
                setCanPlay(true);
            }
        });
        AuthMe(res => {
            setMyInfo(res);
        });

        Get(id, res => {
            setData(res);
            setDeviceAi(res.device_info || 'N');
        });

        return () => {
            if (audio) audio.pause();
        };
    }, []);

    const loadLastData = () => {
        // 센서 시계열은 GetListLast 폴링(reloadSenseSeries)으로 리로드
    };

    useEffect(() => {}, []);

    const procData = (data, recieveData, options = {}) => {
        if (!data || !recieveData) return;
        const skipSeries = !!options.skipSeries;
        const hrRrOnly = !!options.hrRrOnly;

        var heart = recieveData[0];
        var resp = recieveData[1];
        var apnea = recieveData[2];
        var state = recieveData[3];
        var fsr_sum = recieveData[4];
        var motion_detected = 0;

        if (recieveData.length >= 11) {
            motion_detected = recieveData[11];
        }

        if (hrRrOnly) {
            if (!data.resp_range_from) {
                data.heart_range_from = 60;
                data.heart_range_to = 100;
                data.resp_range_from = 10;
                data.resp_range_to = 30;
            }
            data.warnning_heart = heart < data.heart_range_from || heart > data.heart_range_to;
            data.warnning_resp = resp < data.resp_range_from || resp > data.resp_range_to;
            setValue1(heart);
            setValue2(resp);
            setisApnea(apnea);
            if (isUseRef.current) setLastMeasuredAt(moment().toISOString());
            return;
        }

        if (data) {
            data.motion_detected = motion_detected;
            setMotionDetected(motion_detected);
            if (!data.resp_range_from) {
                data.heart_range_from = 60;
                data.heart_range_to = 100;
                data.resp_range_from = 10;
                data.resp_range_to = 30;
            }

            setDeviceAi(data.device_info);

            if (!data.online) {
                data.online = true;
                data.connectTime = moment();

                const heart_ranges = data.heart_range?.split('~');
                if (heart_ranges?.length >= 2) {
                    data.heart_range_from = heart_ranges[0];
                    data.heart_range_to = heart_ranges[1];
                }

                const resp_ranges = data.resp_range?.split('~');
                if (resp_ranges?.length >= 2) {
                    data.resp_range_from = resp_ranges[0];
                    data.resp_range_to = resp_ranges[1];
                }

                setData({ ...data });
            }

            const hasVitals = Number(heart) > 0 || Number(resp) > 0;
            if (hasVitals) {
                if (canPlay && myInfo?.on_sound === 'Y' && audio) {
                    if (heart < data.heart_range_from || heart > data.heart_range_to || resp < data.resp_range_from || resp > data.resp_range_to) {
                        audio.loop = true;
                        audio.play();
                    } else {
                        audio.pause();
                    }
                }

                data.apnea = apnea;
            } else {
                if (canPlay && myInfo?.on_sound === 'Y' && audio) {
                    audio.pause();
                }
            }
        }

        if(motion_detected === 1) {
            heart = 0;
            resp = 0;
            apnea = 0;
            state = 0;
        }

        data.warnning_heart = heart < data.heart_range_from || heart > data.heart_range_to;
        data.warnning_resp = resp < data.resp_range_from || resp > data.resp_range_to;
        data.recieveTime = moment();

        const time = moment().format('HH:mm:ss');

        if (values1.length > 1) {
            const hrv = getHRV(values1.length > 1 ? value1 : undefined, heart);
            //console.log('hrv', hrv);
            setValue3(hrv);
            values3.push(hrv);
            setValues3([...values3.slice(-60)]);

            label3.push(time);
            setLabel3([...label3.slice(-60)]);
        }


        setValue1(heart);
        setValue2(resp);
        setValue5(fsr_sum);
        setisApnea(apnea);

        const inUse = isOccupiedBySense(fsr_sum, motion_detected);
        isUseRef.current = inUse;
        if (inUse) {
            predictFrozenRef.current = false;
            if (!skipSeries) setLastMeasuredAt(moment().toISOString());
        }

        if (!skipSeries && inUse) {
            // MQTT 시절: values1.push([time, heart, motion_detected]);
            values1.push(heart);
            values2.push(resp);
            values5.push(fsr_sum);
            Apneas.push(apnea);

            setApneas([...Apneas.slice(-60)]);
            setValues1([...values1.slice(-60)]);
            setValues2([...values2.slice(-60)]);
            setValues5([...values5.slice(-60)]);

            label1.push(time);
            label2.push(time);
            label5.push(time);
            setLabel1([...label1.slice(-60)]);
            setLabel2([...label2.slice(-60)]);
            setLabel5([...label5.slice(-60)]);
            seriesHasDataRef.current = true;
        }
    };

    const getHRV = (val1, val2) => {
        if (val1) {
            return Math.abs(val2 - val1);
        }
        return 0;
    };

    // 압력 임계값 미달이어도 움직임이면 사용 중. 진짜 미사용만 그래프·예측 중지
    const isUse = isOccupiedBySense(value5, value6);
    const lastMeasuredText = lastMeasuredAt && moment(lastMeasuredAt).isValid()
        ? moment(lastMeasuredAt).format('YYYY-MM-DD HH:mm:ss')
        : '';
    const lastMeasuredLabel = lastMeasuredText ? `마지막 측정 ${lastMeasuredText}` : '';
    const usageClock = !usage?.in_use
        ? null
        : usage.session_started_at && moment(usage.session_started_at).isValid()
          ? gapTime(usage.session_started_at)
          : usage.usage_hm || null;
    const latestAiRow = (aiRows || []).find(row => row && row.score != null);
    const lastPredictAt =
        latestAiRow?.predicted_at || latestAiRow?.to || latestAiRow?.from || aiTo || aiFrom;
    const lastPredictText = lastPredictAt && moment(lastPredictAt).isValid()
        ? moment(lastPredictAt).format('YYYY-MM-DD HH:mm:ss')
        : '';
    const lastPredictLabel = lastPredictText ? `마지막 예측 ${lastPredictText}` : '';

    // 예측 등급: score 60 이하 안전 / 60~79 주의 / 80~ 위험
    const getAiSeverity = () => {
        if (!isUse) return 'ai-paused';
        if (aiReady === false) return 'ai-unavailable';
        if (aiScore != null && !Number.isNaN(Number(aiScore))) {
            const s = Number(aiScore);
            if (s <= 60) return 'goods';
            if (s < 80) return 'warning';
            return 'ai-high';
        }
        if (aiLabel === '높음') return 'ai-high';
        if (aiLabel === '주의') return 'warning';
        if (aiLabel === '낮음') return 'goods';
        return '';
    };

    const getAiBadgeColor = () => {
        const sev = getAiSeverity();
        if (sev === 'ai-high') return '#ff4d4f';
        if (sev === 'warning') return '#faad14';
        if (sev === 'goods') return '#52c41a';
        return '#999999';
    };

    const getAiRiskText = () => {
        if (!isUse) return '미사용 · 예측 중지';
        if (aiReady === false) return '데이터 부족으로 인한 예측 불가';
        if (aiEmpty) return '데이터 없음';
        const sev = getAiSeverity();
        if (sev === 'goods') return '안전';
        if (sev === 'warning') return '주의';
        if (sev === 'ai-high') return '위험';
        if (aiError) return '수집중';
        return '측정중';
    };

    const getAiPredictChartOption = () => {
        const rows = [...(aiRows || [])]
            .filter(row => row && row.score != null)
            .reverse();
        const labels = rows.map((row, i) => {
            const t = row.predicted_at || row.to || row.from;
            return t ? moment(t).format('HH:mm') : String(i + 1);
        });
        const scores = rows.map(row => Number(row.score));

        return {
            color: ['#faad14'],
            animation: true,
            animationDuration: 3000,
            animationDurationUpdate: 3000,
            animationEasing: 'cubicOut',
            tooltip: {
                trigger: 'axis',
                formatter: params => {
                    const p = Array.isArray(params) ? params[0] : params;
                    return `${p?.axisValue || ''}<br/>score: <b>${p?.data ?? '-'}</b>`;
                },
            },
            grid: {
                top: 28,
                left: 48,
                right: 24,
                bottom: 32,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: labels,
                axisLabel: { fontSize: 11, color: '#777', hideOverlap: true },
                axisLine: { lineStyle: { color: '#ddd' } },
            },
            yAxis: {
                type: 'value',
                name: 'score',
                min: 0,
                max: 100,
                nameTextStyle: { color: '#999', fontSize: 11 },
                axisLabel: { fontSize: 11, color: '#777' },
                splitLine: { lineStyle: { color: '#eee' } },
            },
            series: [
                {
                    name: 'score',
                    type: 'line',
                    smooth: true,
                    showSymbol: rows.length <= 30,
                    symbolSize: 6,
                    data: scores,
                    lineStyle: { width: 2, color: '#faad14' },
                    itemStyle: { color: '#faad14' },
                    areaStyle: { opacity: 0.08, color: '#faad14' },
                    markLine: {
                        silent: true,
                        symbol: 'none',
                        animation: true,
                        animationDuration: 3000,
                        animationDurationUpdate: 3000,
                        data: [
                            { yAxis: 60, lineStyle: { color: '#52c41a', type: 'dashed' }, label: { formatter: '안전', color: '#52c41a' } },
                            { yAxis: 80, lineStyle: { color: '#ff4d4f', type: 'dashed' }, label: { formatter: '위험', color: '#ff4d4f' } },
                        ],
                    },
                },
            ],
        };
    };

    const aiPredictChartOption = useMemo(() => getAiPredictChartOption(), [aiRows, aiLineTick]);

    // 심박수 컬러
    const heartColor = '#F75C5D';

    // 호흡수 컬러
    const breathColor = '#3889ff';

    // 산소탈포화지수 컬러
    const oxygenColor = '#38ac1f';

    // 압력값 컬러
    const fsrColor = '#3fd3d4';

    const getOption1 = show => {
        return {
            tooltip: {
                show,
                trigger: 'axis',
                axisPointer: {
                    lineStyle: {
                        color: heartColor,
                        width: 2,
                    },
                },
                formatter: `{c} BPM`,
                textStyle: {
                    color: 'black',
                    fontWeight: 'bold',
                    fontFamily: 'Pretendard',
                    fontSize: 13,
                },
            },
            xAxis: {
                show,
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: '#dddddd',
                    },
                },
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                boundaryGap: false,
                data: label1,
            },
            yAxis: {
                show,
                type: 'value',
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                min: 0,
                max: 120,
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40,
            },
            // MQTT 시절 values1=[time,heart,motion]용 visualMap — 서버 폴링은 숫자 배열이라 비활성
            // visualMap: [
            //     {
            //         show: false,
            //         dimension: 1,
            //         min: 0,
            //         max: 1,
            //         inRange: {
            //             color: ['#CCCCCC', 'red']
            //         }
            //     },
            // ],
            series: [
                {
                    name: 'BPM',
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    itemStyle: {
                        // color: heartColor,
                        borderWidth: 20,
                        borderType: 'solid',
                        opacity: 0.9,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(255, 91, 69, 1)',
                            },
                            {
                                offset: 0.4,
                                color: 'rgba(239, 218, 17, 1)',
                            },
                            {
                                offset: 0.7,
                                color: 'rgba(174, 250, 90, 1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(255, 255, 255, 0)',
                            },
                        ]),
                    },
                    // lineStyle: {
                    //     color: heartColor,
                    //     width: 4,
                    // },
                    markLine: {
                        symbol: 'none',
                        data: show
                            ? [
                                  {
                                      name: t('정상'),
                                      yAxis: data?.heart_range_from ? (data?.heart_range_from + data?.heart_range_to) / 2 : 80,
                                      label: {
                                          color: '#3989FF',
                                      },
                                      lineStyle: {
                                          color: '#3989FF',
                                      },
                                  },
                                  {
                                      name: t('경고'),
                                      yAxis: data?.heart_range_from ? data?.heart_range_from : 60,
                                      label: {
                                          color: '#FC9D3C',
                                      },
                                      lineStyle: {
                                          color: '#FC9D3C',
                                      },
                                  },
                                  {
                                      name: t('위험'),
                                      yAxis: data?.heart_range_to ? data?.heart_range_to : 100,
                                      label: {
                                          color: '#F75C5D',
                                      },
                                      lineStyle: {
                                          color: '#F75C5D',
                                      },
                                  },
                              ]
                            : [],
                        label: {
                            formatter: `{b}`,
                            fontWeight: 700,
                            fontFamily: 'Pretendard',
                        },
                        lineStyle: {
                            type: 'solid',
                        },
                    },
                    data: values1,


                    // renderItem: function(params, api) {
                    //     var valueType = api.value(2);
                    //     var color = valueType === 0 ? "red": "green";

                    //     let coord1 = api.coord([api.value(0, params.dataIndexInside), api.value(1, params.dataIndexInside)]),
                    //         coord2 = api.coord([api.value(0, params.dataIndexInside+1), api.value(1, params.dataIndexInside+1)]);

                    //     return {
                    //         type: "line",
                    //         shape: {
                    //             x1: coord1[0],
                    //             y1: coord1[1],
                    //             x2: coord2[0],
                    //             y2: coord2[1]
                    //         },
                    //         style: api.style({stroke:color, lineWidth: 4, smooth: true}),
                    //         smooth: true,
                    //         itemStyle: {
                    //             renderPoints: false
                    //         }
                    //     }
                    // }, 
                },
            ],
        };
    };

    const getOption2 = show => {
        return {
            tooltip: {
                show,
                trigger: 'axis',
                axisPointer: {
                    lineStyle: {
                        color: breathColor,
                        width: 2,
                    },
                },
                formatter: `{c} ${t('회')}`,
                textStyle: {
                    color: 'black',
                    fontWeight: 'bold',
                    fontFamily: 'Pretendard',
                    fontSize: 13,
                },
            },
            xAxis: {
                show,
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: '#dddddd',
                    },
                },
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                boundaryGap: false,
                data: label2,
            },
            yAxis: {
                show,
                type: 'value',
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                min: 0,
                max: 40,
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40,
            },
            series: [
                {
                    name: 'BPM',
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    itemStyle: {
                        color: breathColor,
                        borderWidth: 20,
                        borderType: 'solid',
                        opacity: 0.9,
                    },
                    lineStyle: {
                        color: breathColor,
                        width: 4,
                    },
                    markLine: {
                        symbol: 'none',
                        data: show
                            ? [
                                  {
                                      name: t('정상'),
                                      yAxis: data?.resp_range_from ? (data?.resp_range_from + data?.resp_range_to) / 2 : 15,
                                      label: {
                                          color: '#3989FF',
                                      },
                                      lineStyle: {
                                          color: '#3989FF',
                                      },
                                  },
                                  {
                                      name: t('경고'),
                                      yAxis: data?.resp_range_from ? data?.resp_range_from : 10,
                                      label: {
                                          color: '#FC9D3C',
                                      },
                                      lineStyle: {
                                          color: '#FC9D3C',
                                      },
                                  },
                                  {
                                      name: t('위험'),
                                      yAxis: data?.resp_range_to ? data?.resp_range_to : 20,
                                      label: {
                                          color: '#F75C5D',
                                      },
                                      lineStyle: {
                                          color: '#F75C5D',
                                      },
                                  },
                              ]
                            : [],
                        label: {
                            formatter: `{b}`,
                            fontWeight: 700,
                            fontFamily: 'Pretendard',
                        },
                        lineStyle: {
                            type: 'solid',
                        },
                    },
                    data: values2,
                },
            ],
        };
    };

    const getOption3 = show => {
        return {
            tooltip: {
                show,
                trigger: 'axis',
                axisPointer: {
                    lineStyle: {
                        color: oxygenColor,
                        width: 2,
                    },
                },
                formatter: `{c} ${t('회')}`,
                textStyle: {
                    color: 'black',
                    fontWeight: 'bold',
                    fontFamily: 'Pretendard',
                    fontSize: 13,
                },
            },
            xAxis: {
                show,
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: '#dddddd',
                    },
                },
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                boundaryGap: false,
                data: label3,
            },
            yAxis: {
                show,
                type: 'value',
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                // min: 75,
                // max: 100,
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40,
            },
            series: [
                {
                    name: 'BPM',
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    itemStyle: {
                        // color: oxygenColor,
                        borderWidth: 20,
                        borderType: 'solid',
                        opacity: 0.9,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(255, 91, 69, 1)',
                            },
                            {
                                offset: 0.4,
                                color: 'rgba(239, 218, 17, 1)',
                            },
                            {
                                offset: 0.7,
                                color: 'rgba(174, 250, 90, 1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(255, 255, 255, 0)',
                            },
                        ]),
                    },
                    lineStyle: {
                        color: oxygenColor,
                        width: 4,
                    },
                    // markLine: {
                    //     symbol: 'none',
                    //     data: [
                    //         {
                    //             name: t('정상'),
                    //             yAxis: 100,
                    //             label: {
                    //                 color: '#3989FF',
                    //             },
                    //             lineStyle: {
                    //                 color: '#3989FF',
                    //             },
                    //         },
                    //         {
                    //             name: t('경고'),
                    //             yAxis: 90,
                    //             label: {
                    //                 color: '#FC9D3C',
                    //             },
                    //             lineStyle: {
                    //                 color: '#FC9D3C',
                    //             },
                    //         },
                    //         {
                    //             name: t('위험'),
                    //             yAxis: 80,
                    //             label: {
                    //                 color: '#F75C5D',
                    //             },
                    //             lineStyle: {
                    //                 color: '#F75C5D',
                    //             },
                    //         },
                    //     ],
                    //     label: {
                    //         formatter: `{b}`,
                    //         fontWeight: 700,
                    //         fontFamily: 'Pretendard',
                    //     },
                    //     lineStyle: {
                    //         type: 'solid',
                    //     },
                    // },
                    data: values3,
                },
            ],
        };
    };

    const getOption5 = show => {
        return {
            tooltip: {
                show,
                trigger: 'axis',
                axisPointer: {
                    lineStyle: {
                        color: oxygenColor,
                        width: 2,
                    },
                },
                formatter: `{c} ${t('회')}`,
                textStyle: {
                    color: 'black',
                    fontWeight: 'bold',
                    fontFamily: 'Pretendard',
                    fontSize: 13,
                },
            },
            xAxis: {
                show,
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: '#dddddd',
                    },
                },
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                boundaryGap: false,
                data: label5,
            },
            yAxis: {
                show,
                type: 'value',
                axisLabel: {
                    color: '#777777',
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Pretendard',
                },
                // min: 75,
                // max: 100,
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40,
            },
            series: [
                {
                    name: 'FSR',
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    itemStyle: {
                        // color: oxygenColor,
                        borderWidth: 20,
                        borderType: 'solid',
                        opacity: 0.9,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(255, 91, 69, 1)',
                            },
                            {
                                offset: 0.4,
                                color: 'rgba(239, 218, 17, 1)',
                            },
                            {
                                offset: 0.7,
                                color: 'rgba(174, 250, 90, 1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(255, 255, 255, 0)',
                            },
                        ]),
                    },
                    lineStyle: {
                        color: fsrColor,
                        width: 4,
                    },
                    data: values5,
                },
            ],
        };
    };

    const displayHr = isUse ? value1 : 'NaN';
    const displayRr = isUse ? value2 : 'NaN';
    const warnHeart = !!data?.warnning_heart;
    const warnResp = !!data?.warnning_resp;
    var iconSet = 0;
    if (data?.device_sn?.startsWith('C', 0)) {
        iconSet = 2;
    } else {
        iconSet = 1;
    }
    const motion_detected = value6;
    const showMotion = motion_detected === 1;
    const heartClassName = showMotion
        ? 'h-motion-detected'
        : 'heart' + (isUse && warnHeart ? ' on' : '');
    const breathClassName = showMotion
        ? 'r-motion-detected'
        : 'breath' + (isUse && warnResp ? ' on' : '');

    const isApnea_v=isApnea;

    var username="";

    if(i18n.resolvedLanguage==="en"){
        username=data?.user?.name_eng;
    }else{
        username=data?.user?.name;
    }


    return (
        <main className="admin-contents">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <h2 className="sub_title" style={{ flex: 1 }}>
                    {t('사용자 상세 보기')}
                </h2>
                <div className="pc-menu">
                    <button
                        type="button"
                        className="btn_nor md"
                        style={{ display: 'flex', alignItems: 'center', marginRight: 4, ...(showType === 'cell' ? { backgroundColor: '#FC9E3C' } : {}) }}
                        onClick={e => {
                            setShowType('cell');
                        }}
                    >
                        <AiOutlineAppstore style={{ width: 20, height: 20 }} />
                        {t('보기')}
                    </button>
                    <button
                        type="button"
                        className="btn_nor md"
                        style={{ display: 'flex', alignItems: 'center', ...(showType === 'list' ? { backgroundColor: '#FC9E3C' } : {}) }}
                        onClick={e => {
                            setShowType('list');
                        }}
                    >
                        <BsList style={{ width: 20, height: 20 }} />
                        {t('보기')}
                    </button>
                </div>
            </div>


            <section className="monitoring_person_info_box">
                <div className="data">
                    <p>
                        {data?.online ? (
                            usageClock ? (
                                <span className="time" key={usageTick}>{usageClock}</span>
                            ) : null
                        ) : (
                            <span className="alert">{t('없음')}</span>
                        )}
                    </p>
                    <p>
                        <b>{data?.device_no}</b>
                    </p>
                    <p>
                        <b>{data?.device_sn}</b>
                    </p>
                    <p>
                        <span className="state">{data?.online ? 'ON' : 'OFF'}</span>
                    </p>
                </div>
                <div className="per_info">
                    <p className="pic">
                        <img src="https://picsum.photos/200/300" alt={t('프로필')} />
                    </p>

                    <p className="name">{username}</p>
                    <p className="age">
                        {calculateAge(data?.user?.birth)}
                        {t('세')}
                    </p>
                    <p className="gender">{t(typeSex[data?.user?.sex])}</p>
                    <p className="addr">
                        {data?.user?.addr1} {data?.user?.addr2}
                    </p>
                </div>
            </section>

            {device_AI === "Y" && (
                <section className="monitoring_signal_list">
                    <ul>
                    <li className={`AI ${getAiSeverity()}`}>
                        <p className="title">
                        심정지 위험도 <b>AI 예측</b>
                        {isUse && aiReady !== false && aiScore != null && (
                            <span
                            className={`ai-badge ${getAiSeverity()}`}
                            style={{
                                marginLeft: 8,
                                padding: '4px 8px',
                                borderRadius: '6px',
                                backgroundColor: getAiBadgeColor(),
                                color: 'white',
                                fontWeight: 'bold',
                            }}
                            >
                            {Number(aiScore).toFixed(2)}
                            </span>
                        )}
                        </p>
                        <p className="data" style={{ flexWrap: 'wrap', gap: 8, height: 'auto' }}>
                        <strong>
                            상태: <b>{getAiRiskText()}</b>
                        </strong>
                        {isUse && aiReady === false && (
                            <span style={{ flexBasis: '100%', textAlign: 'right', fontSize: 14 }}>
                                {aiObserved != null && aiRequired != null
                                    ? `${aiObserved}/${aiRequired}분 수집됨 · 60분 데이터 필요`
                                    : '60분 데이터가 쌓이기 전에는 예측할 수 없습니다'}
                            </span>
                        )}
                        {aiError && (
                            <span style={{ marginLeft: 8, fontSize: 14 }}>
                                {aiError}
                            </span>
                        )}
                        </p>
                        {aiReady !== false && aiRows.some(row => row?.score != null) && (
                            <div className={!isUse ? 'ai-chart-paused' : ''} style={{ marginTop: 16, overflow: 'hidden', position: 'relative' }}>
                                <div className="graph-chart-meta">
                                    {!isUse && <span className="paused-badge">미사용 · 그래프 중지</span>}
                                    {lastPredictLabel && <span className="last_measured">{lastPredictLabel}</span>}
                                </div>
                                <ECharts
                                    key={aiLineTick}
                                    option={aiPredictChartOption}
                                    opts={{ renderer: 'svg', width: 'auto' }}
                                    style={{ height: 220, width: '100%' }}
                                />
                            </div>
                        )}
                    </li>
                    </ul>
                </section>
                )}

            {showType === 'list' && [
                <section className="monitoring_signal_list">
                    <ul>
                        <li>
                            <div className="graph_wrap">
                                {(lastMeasuredLabel || !isUse) && (
                                    <div className="graph-chart-meta" style={{ width: '100%', padding: '0 8px 8px' }}>
                                        {!isUse && <span className="paused-badge">미사용 · 그래프 중지</span>}
                                        {lastMeasuredLabel && <span className="last_measured">{lastMeasuredLabel}</span>}
                                    </div>
                                )}
                                <article className="graph_arti" style={{ height: 140, display: 'flex', flexDirection: 'row' }}>
                                    <div className="graph_box" style={{ height: 140, flex: 1 }}>
                                        <ECharts notMerge lazyUpdate option={getOption1(false)} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 140 }} />
                                    </div>
                                    <ul style={{ width: 180 }}>
                                        <li
                                            // className={'heart' + (isUse && data?.warnning_heart ? ' on' : '')  }
                                            // className={ motion_detected === 1? 'motion-detected': 'heart' +(isUse && data?.warnning_heart ? ' on' : '')  }
                                            className={heartClassName}
                                            // className={getHeartClassName(isUse, data, motion_detected) }
                                            style={{ borderColor: '#aaaaaa', borderWidth: 1, borderStyle: 'solid', padding: 20 }}
                                        >
                                            <p className="title">
                                                {/* <b>{t('심박수')}</b> */}
                                                <b>HR</b>
                                            </p>
                                            <p className="data">
                                                <strong>{displayHr}</strong>
                                            </p>
                                        </li>
                                    </ul>
                                </article>

                                <article className="graph_arti" style={{ height: 140, display: 'flex', flexDirection: 'row', marginTop: 4 }}>
                                    <div className="graph_box" style={{ height: 140, flex: 1 }}>
                                        <ECharts notMerge lazyUpdate option={getOption2(false)} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 140 }} />
                                    </div>
                                    <ul style={{ width: 180 }}>
                                        <li
                                            className={breathClassName}
                                            style={{ borderColor: '#aaaaaa', borderWidth: 1, borderStyle: 'solid', padding: 20 }}
                                        >
                                            <p className="title">
                                                {/* <b>{t('호흡수')}</b> */}
                                                <b>RR</b>
                                            </p>
                                            <p className="data">
                                                <strong>{displayRr}</strong>
                                            </p>
                                        </li>
                                    </ul>
                                </article>

                                <article className="graph_arti" style={{ height: 140, display: 'flex', flexDirection: 'row', marginTop: 4 }}>
                                    <div className="graph_box" style={{ height: 140, flex: 1 }}>
                                        <ECharts notMerge lazyUpdate option={getOption5(false)} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 140 }} />
                                    </div>
                                    <ul style={{ width: 180 }}>
                                        <li
                                            className={'fsr' + (isUse && data?.warnning_fsr ? ' on' : '')}
                                            style={{ borderColor: '#aaaaaa', borderWidth: 1, borderStyle: 'solid', padding: 20 }}
                                        >
                                            <p className="title">
                                                <b>FSR</b>
                                            </p>
                                            <p className="data">
                                                <strong>{value5}</strong>
                                            </p>
                                        </li>
                                    </ul>
                                </article>
                            </div>
                        </li>
                    </ul>
                </section>,
            ]}

            {showType === 'cell' && [
                <section className="monitoring_signal_list">
                    <ul>
                        {/* <li className={'heart' + (isUse && data?.warnning_heart ? ' on' : '')}> */}
                        <li className={heartClassName}>
                            <p className="title">
                                <b>{t('심박수')}</b>(BPM)
                            </p>
                            <p className="data">
                                <strong>{displayHr}</strong> BPM
                            </p>
                        </li>
                        <li className={breathClassName}>
                            <p className="title">
                                <b>{t('호흡수')}</b>(BPM)
                            </p>
                            <p className="data">
                                <strong>
                                    {!isUse
                                        ? 'NaN'
                                        : showMotion
                                          ? '0'
                                          : isApnea_v == 1
                                            ? <img src={Apnea_icon} className="icon_act_apnea" />
                                            : displayRr}
                                </strong>{' '}
                                {isUse
                                    ? showMotion
                                        ? 'BPM'
                                        : isApnea_v == 1
                                          ? <span className="apnea_text">{t('무호흡')}</span>
                                          : 'BPM'
                                    : 'BPM'}
                            </p>
                        </li>
                        {/* <li className="oxygen">
                        <p className="title">
                            <b>{t('산소탈포화지수')}</b>(ODI)
                        </p>
                        <p className="data">
                            <strong>{value3}</strong> {t('회')}
                        </p>
                    </li> */}
                        <li className="fsr">
                            <p className="title">
                                <b>{t('사용 여부')}</b>

                                <b className="title_val">{`${t('압력값')} : ${value5}`}</b>
                            </p>
                            <p className="data">
                            <div class="icon_act">
                                {showMotion ? (
                                    <img src={UseIcon_m} className="icon_act_fsr" />
                                ) : iconSet === 2 ? (
                                    <img src={isUse ? UseIcon_c : UnUseIcon} className="icon_act_fsr" />
                                ) : (
                                    <img src={isUse ? UseIcon_b : UnUseIcon} className="icon_act_fsr" />
                                )}
                            </div>
                            <strong>
                                {isUse ? (showMotion ? t('움직임 감지') : t('사용 중')) : t('미사용')}
                            </strong>           
                            </p>
                        </li>
                    </ul>
                </section>,

                <section className="monitoring_time_graph">
                    <h4>REAL TIME GRAPH</h4>

                    <div className="graph_wrap">
                        <article className='graph_arti hrv_graph' style={{height: 1000 }}>
                            <div className="top">
                                <span>
                                    <em></em> HRV
                                </span>
                                {lastMeasuredLabel ? <span className="last_measured">{lastMeasuredLabel}</span> : null}
                            </div>
                            <div className="graph_box" style={{ height: 900 }}>
                                <HrvDash
                                    data={data}
                                    paused={!isUse}
                                    onSenseUpdate={vitals => {
                                        const device = dataRef.current;
                                        if (!device || !vitals) return;
                                        lastMqttAtRef.current = Date.now();
                                        const inUse = isOccupiedBySense(vitals.fsr, vitals.motion);
                                        isUseRef.current = inUse;
                                        if (inUse) predictFrozenRef.current = false;
                                        setValue5(vitals.fsr);
                                        setMotionDetected(vitals.motion);
                                        if (!device.online) {
                                            device.online = true;
                                            device.connectTime = moment();
                                            setData({ ...device });
                                        }
                                        device.motion_detected = vitals.motion;
                                        device.recieveTime = moment();
                                    }}
                                    hr={value1}
                                    rr={value2}
                                    apnea={isApnea}
                                />
                            </div>
                            {/* <div className="bottom">
                                <span>
                                    {t('HRV 채널 별 신호')}
                                </span>
                            </div> */}
                        </article>
                        <article className="graph_arti heart_graph" style={{ height: 356 }}>
                            <div className="top">
                                <span>
                                    <em></em> {t('심박수')}
                                </span>
                                {lastMeasuredLabel ? <span className="last_measured">{lastMeasuredLabel}</span> : null}
                            </div>
                            <div className="graph_box" style={{ height: 280 }}>
                                <ECharts notMerge lazyUpdate option={getOption1(true)} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 280 }} />
                            </div>
                            <div className="bottom">
                                <span>
                                    {t('정상 심박수 범위')} : {data?.heart_range_from ? data?.heart_range_from : 60}-
                                    {data?.heart_range_to ? data?.heart_range_to : 100} BPM
                                </span>
                            </div>
                        </article>

                        {/* <article className="graph_arti heart_graph" style={{ height: 320 }}>
                        <div className="top">
                            <span>{t('심박변이도')}(HRV)</span> */}
                        {/* <span>정상 심박수 범위 : 60-100 BPM</span> */}
                        {/* </div>
                        <div className="graph_box" style={{ height: 280 }}>
                            <ECharts option={getOption4()} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 280 }} />
                        </div>
                    </article> */}

                        {/* <article className="graph_arti oxygen_graph" style={{ height: 356 }}>
                            <div className="top">
                                <span>
                                    <em></em> {t('심박변이도')}(HRV)
                                </span>
                            </div>
                            <div className="graph_box" style={{ height: 280 }}>
                                <ECharts option={getOption3(true)} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 280 }} />
                            </div>
                            <div className="bottom">
                                <span></span>
                            </div>
                        </article> */}

                        <article className="graph_arti breath_graph" style={{ height: 356 }}>
                            <div className="top">
                                <span>
                                    <em></em> {t('호흡수')}
                                </span>
                                {lastMeasuredLabel ? <span className="last_measured">{lastMeasuredLabel}</span> : null}
                            </div>
                            <div className="graph_box" style={{ height: 280 }}>
                                <ECharts notMerge lazyUpdate option={getOption2(true)} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 280 }} />
                            </div>
                            <div className="bottom">
                                <span>
                                    {t('정상 호흡수 범위')} : {data?.resp_range_from ? data?.resp_range_from : 10}~
                                    {data?.resp_range_to ? data?.resp_range_to : 30} BPM
                                </span>
                            </div>
                        </article>

                        <article className="graph_arti oxygen_graph" style={{ height: 356 }}>
                            <div className="top">
                                <span>
                                    <em></em> FSR
                                </span>
                                {lastMeasuredLabel ? <span className="last_measured">{lastMeasuredLabel}</span> : null}
                            </div>
                            <div className="graph_box" style={{ height: 280 }}>
                                <ECharts notMerge lazyUpdate option={getOption5(true)} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 280 }} />
                            </div>
                            <div className="bottom">
                                <span>
                                    {t('압력값')} : {value5}
                                </span>
                            </div>
                        </article>

                        {/* <article className="graph_arti oxygen_graph" style={{ height: 320 }}>
                        <div className="top">
                            <span>
                                <em></em> {t('산소탈포화지수')}
                            </span>
                        </div>
                        <div className="graph_box" style={{ height: 280 }}>
                            <ECharts option={getOption3()} opts={{ renderer: 'svg', width: 'auto' }} style={{ height: 280 }} />
                        </div>
                    </article> */}

                    </div>
                </section>,
            ]}

            <MonitoringDetailBottom data={data} />
        </main>
    );
};

export default MonitoringDetail;
